import { Controller } from "@hotwired/stimulus"

// AI Visibility の競合行で、自動推定したドメインをドメイン欄へ入れる(#1159)。
//
// AiVisibilityCompetitorDomainJob は推定で domains を保存したときだけ、行内の非表示スロットへ
// <span data-domain-autofill-target="estimate" data-value="example.com"> を turbo_stream.update で流し込む。
// 入力欄そのものを差し替えると、入力中の要素が DOM から外れて blur → change が起き、autosave-row が
// 入力途中の値を PATCH してしまうため、値だけをここで受け渡す。
//
//   - ドメイン欄が空のときだけ値を入れる(空でなければユーザーが入力中か入力済みなので触らない)
//   - ドメイン欄にフォーカスがあるときも入れない(打ち始める直前に値が入ると、ユーザーの入力とつながってしまう)
//   - サーバー側では保存済みなので change / input は発火させない(autosave-row に再送させない)
//   - フォーカスは動かさない
//
// 使い方(view):
//   form data-controller="autosave-row domain-autofill"
//     input data-domain-autofill-target="input"
//     span#..._domain_estimate hidden   ← ここに estimate ターゲットが届く
export default class extends Controller {
  static targets = ["input", "estimate"]

  estimateTargetConnected(element) {
    const value = (element.dataset.value || "").trim()
    if (value !== "" && this.hasInputTarget && this.inputTarget.value.trim() === "" && !this.inputFocused()) {
      this.inputTarget.value = value
    }
    // 受け渡し用のマーカーなので、値を入れなかった場合も取り除く(次の配信はスロットの update で新しく届く)
    element.remove()
  }

  inputFocused() {
    return typeof document !== "undefined" && document.activeElement === this.inputTarget
  }
}
